import { call, put } from 'redux-saga/effects';
import { fetchReceipts } from 'modules/Checks/api';
import { getChecksSuccess } from 'modules/Taps/components/NDFL3/NDFL3Actions';
import REACT_CONFIG from 'REACT_CONFIG';

export function* initDeductionsSaga() {
  if (!REACT_CONFIG.REACT_APP_HIDE_CHECKS) {
    const checks = yield call(fetchReceipts);
    yield put(getChecksSuccess(checks));
  }
}
